import { useCallback, useEffect, useState } from 'react';

/**
 * A wait the person can see ("You can send it again in 42 seconds"), counted down once a second.
 *
 * @returns The seconds left (0 when none) and `start(seconds)`
 */
export function useCountdown(): [number, (seconds: number) => void] {
	const [until, setUntil] = useState(0);
	const [now, setNow] = useState(() => Date.now());

	useEffect(() => {
		if (until <= now) return;
		const timer = setTimeout(() => setNow(Date.now()), 1000);
		return () => clearTimeout(timer);
	}, [until, now]);

	const start = useCallback((seconds: number) => {
		const at = Date.now();
		setNow(at);
		setUntil(at + Math.max(0, seconds) * 1000);
	}, []);
	return [Math.max(0, Math.ceil((until - now) / 1000)), start];
}
